import React, { useState, useContext, useEffect, useCallback } from "react";
import { useTranslation } from 'react-i18next';

import './style.css';
import PermissionGate from "../../services/PermissionGate";

import styled from 'styled-components';
import { SidebarContext } from "../../AppRoutes";

import { getQrCodeWhatsapp } from "../../services/api";
import Loading from "react-loading";

const Teste = styled.div`
    display: flex;
    margin-left:  ${({ sidebar }) => (sidebar ? '250px' : '100px')}; 
    height:auto;
    width:auto;
    transition: 150ms;
    background-color:rgb(255,255,255)!important;
    overflow: initial;
    z-Index: 9;
    
    @media (max-width: 768px) {
        margin-left: 0;
        height: 100vh;
        width: 100vw;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
    }
`;

// Hook para detectar mobile
function useIsMobile() {
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
    React.useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
    return isMobile;
}

const WhatsappSync = () => {
    const { t } = useTranslation('whatsapp');
    const { sidebar } = useContext(SidebarContext);; //TESTANDO CONST NO AppROUTES
    // const [isSubmitting, setIsSubmitting] = useState(false);

    const [qrCodeImg, setQrCodeImg] = useState('');
    const [generatingQrCode, setGeneratingQrCode] = useState(false);
    // const [isLoged, setIsLoged] = useState(false);
    const isMobile = useIsMobile();

    const fetchQrCode = useCallback(() => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Fetching QR Code...');
        setGeneratingQrCode(true);
        getQrCodeWhatsapp('65b03b8c756df35f6333a9fb').then((response) => {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('API Response:', response);

            if (response.data.qrcode.error === 'is_loged') {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('User is logged in, stopping QR code regeneration.');
                // setIsLoged(true);
                setGeneratingQrCode(false);
                return;
            }

            setQrCodeImg(response.data.qrcode.qr);

            const ttl = response.data.qrcode.ttl;
            const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Current Time:', currentTime);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('TTL:', ttl);

            const timeoutDuration = (ttl + 30 - currentTime) * 1000; // Time until 30 seconds after ttl in milliseconds
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Timeout Duration (ms):', timeoutDuration);

            if (timeoutDuration > 0) {
                setTimeout(() => {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Regenerating QR Code...');
                    fetchQrCode();
                }, timeoutDuration);
            } else {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('TTL has already passed.');
            }
        }).catch((error) => {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Error:', error);
            setGeneratingQrCode(false);
        }).finally(() => {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Finally block executed.');
            setGeneratingQrCode(false);
        });
    }, []);

    useEffect(() => {
        fetchQrCode();
    }, [fetchQrCode]);

    // const handleBack = () => {
    //     navigate("/list-item");
    // };

    return (
        <>
            <PermissionGate permissions={['default']}>
                {/*<LeftMenu setSidebar={setSidebar} sidebar={sidebar} />*/}
                <Teste sidebar={sidebar}>
                    <div className="m-5" style={{ 
                        margin: isMobile ? '10px' : '20px',
                        width: isMobile ? '100%' : 'auto',
                        padding: isMobile ? '0 10px' : '0'
                    }}>
                        <form style={{ marginTop: isMobile ? "0px" : "-30px" }}>
                            <div className="form-header" style={{ marginBottom: "0px" }}>
                                <div className="title">
                                    <h1 style={{ 
                                        fontSize: isMobile ? '1.5rem' : '2rem',
                                        textAlign: isMobile ? 'center' : 'left',
                                        marginBottom: isMobile ? '15px' : '20px'
                                    }}>Sincronizar WhatsApp</h1>
                                </div>
                            </div>

                            <div className="contentItemComplete">
                                <div className="input-group inputGroup-adicinaItem">
                                    <div className="formGroupRow">
                                        <div style={{ 
                                            backgroundColor: 'white', 
                                            padding: isMobile ? '15px' : '20px', 
                                            display: 'flex', 
                                            flexDirection: 'column', 
                                            gap: isMobile ? '15px' : '20px', 
                                            margin: 'auto',
                                            borderRadius: isMobile ? '8px' : '4px',
                                            maxWidth: isMobile ? '100%' : 'none'
                                        }}>
                                            <h2 style={{ 
                                                fontSize: isMobile ? '1.3rem' : '1.5rem',
                                                textAlign: isMobile ? 'center' : 'left',
                                                marginBottom: isMobile ? '10px' : '15px'
                                            }}>{t('qrCode.title')}</h2>
                                            <ol style={{
                                                paddingLeft: isMobile ? '15px' : '20px',
                                                fontSize: isMobile ? '14px' : '16px',
                                                lineHeight: '1.5'
                                            }}>
                                                <li style={{ marginBottom: isMobile ? '8px' : '5px' }}>{t('qrCode.steps.step1')}</li>
                                                <li style={{ marginBottom: isMobile ? '8px' : '5px' }}>{t('qrCode.steps.step2')}</li>
                                                <li style={{ marginBottom: isMobile ? '8px' : '5px' }}>{t('qrCode.steps.step3')}</li>
                                                <li style={{ marginBottom: isMobile ? '8px' : '5px' }}>{t('qrCode.steps.step4')}</li>
                                            </ol>
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <div style={{ 
                                                    padding: isMobile ? '8px' : '10px', 
                                                    backgroundColor: 'white', 
                                                    border: '1px solid #E0E0E0', 
                                                    borderRadius: '8px' 
                                                }}>
                                                    <div style={{ 
                                                        width: isMobile ? '280px' : '340px', 
                                                        height: isMobile ? '280px' : '340px', 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        justifyContent: 'center', 
                                                        borderRadius: '8px' 
                                                    }}>
                                                        {
                                                            generatingQrCode ? <Loading type={"spinningBubbles"} className="generatingQrCodeLoading" />
                                                                :
                                                                <img src={`${qrCodeImg}`} alt="QR Code" />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </Teste>
            </PermissionGate>
        </>
    );
};

export default WhatsappSync;
